export default __webpack_public_path__ + "static/media/logo32.eac15bda.jpg";